module.exports = __webpack_public_path__ + "img/wf.2b651380.png";